import {
  apiService,
  extractSyncResponse,
  getModelCount,
  IAnnouncements,
  ISyncChangesResponse,
  notificationDb,
} from '..';

const PAGE_SIZE = 100;
interface IGetAnnouncementsResponse {
  timestamp: string;
  announcements: ISyncChangesResponse<IAnnouncements>;
}
export const fetchNotifications = async (
  timestamp: string | null,
  pageNumber: number = 1,
): Promise<boolean> => {
  const response = await apiService.get<IGetAnnouncementsResponse>(
    `api/v1/sync-announcements/?page_size=${PAGE_SIZE}&page=${pageNumber}&c=${Date.now()}&${
      timestamp ? `last_pulled_at=${timestamp}` : ''
    }`,
  );

  const data = response.data;
  let lastResult = true;
  const models = ['announcements'] as const;

  try {
    const addDataToDb = await extractSyncResponse(models, data, notificationDb);
    console.log(`Added ${models} in db ${addDataToDb}`);
  } catch (e) {
    lastResult = false;
    console.error(`Unable to add data for ${models} ${e}`);
  }

  const modelCounts = getModelCount(models, data);
  const maxPages = Math.max(...modelCounts) / PAGE_SIZE;

  if (pageNumber <= maxPages) {
    // fetch the next page.
    lastResult =
      lastResult && (await fetchNotifications(timestamp, pageNumber + 1));
  }

  return lastResult;
};
